import styled from 'styled-components'

export const BrowserContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const SearchRow = styled.div`
  padding: 0.5rem 0.5rem 0.375rem;
  flex-shrink: 0;
`

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0 0.5rem 0.375rem;
  flex-shrink: 0;
`

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  padding: 0 0.5rem 0.5rem;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border);
`

export const ListRegion = styled.div`
  flex: 1;
  min-height: 0;
`

export const StatusLine = styled.div`
  padding: 0.75rem 0.5rem;
  font-size: 0.6875rem;
  color: var(--muted-foreground);
`

export const TagRowButton = styled.button<{ $columns?: boolean }>`
  width: 100%;
  border: none;
  background: none;
  padding: 0 0.5rem;
  cursor: pointer;
  text-align: left;
  color: var(--foreground);

  ${({ $columns }) =>
    $columns
      ? `
    display: grid;
    grid-template-columns: 1rem minmax(0, 2fr) minmax(0, 3fr) 3rem;
    align-items: center;
    column-gap: 0.5rem;
  `
      : `
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `}

  &:hover {
    background: var(--muted);
  }

  &:focus-visible {
    outline: none;
    background: var(--muted);
    box-shadow: inset 0 0 0 2px var(--ring);
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

export const TagRowText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`

export const TagRowName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.6875rem;
`

export const TagRowDescription = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.625rem;
  color: var(--muted-foreground);
`

export const TagRowUnit = styled.span`
  flex-shrink: 0;
  font-size: 0.625rem;
  font-variant-numeric: tabular-nums;
  color: var(--muted-foreground);
  text-align: right;
`
